import { registerLicense } from '../../misc/Certificates/LicenseRegistry.js';
/**
 * This license gives somebody the right to declare trusted keys for himself.
 *
 * The trust is given by creating an "AffirmationCertificate" pointing to a profile that contains
 * keys.
 */
export const RightToDeclareTrustedKeysForSelfLicense = Object.freeze({
    $type$: 'License',
    name: 'RightToDeclareTrustedKeysForSelf',
    description: '[signature.issuer] gives [beneficiary] the right to declare keys in his own profiles as' +
        ' trusted by issuing Affirmation certificates.'
});
registerLicense(RightToDeclareTrustedKeysForSelfLicense, 'RightToDeclareTrustedKeysForSelfCertificate');
export const RightToDeclareTrustedKeysForSelfCertificateRecipe = {
    $type$: 'Recipe',
    name: 'RightToDeclareTrustedKeysForSelfCertificate',
    rule: [
        {
            itemprop: 'beneficiary',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'license',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['License']) }
        }
    ]
};
export const RightToDeclareTrustedKeysForSelfCertificateReverseMap = ['RightToDeclareTrustedKeysForSelfCertificate', new Set(['*'])];
//# sourceMappingURL=RightToDeclareTrustedKeysForSelfCertificate.js.map